// extracted by mini-css-extract-plugin
export var list = "ImageTextBlock-module--list--84e3c";
export var text = "ImageTextBlock-module--text--90e9e";
export var textBlock = "ImageTextBlock-module--textBlock--0aa34";
export var textList = "ImageTextBlock-module--textList--8c5f9";
export var textOnlyBlock = "ImageTextBlock-module--textOnlyBlock--367c5";
export var videoHeader = "ImageTextBlock-module--videoHeader--68096";